module.exports = __webpack_public_path__ + "static/media/elife-school-2024-1.68937390.gif";